export default "__VITE_ASSET__Bd0ci4M___"